<ng-container appExpandedComponent></ng-container>
